import { Button, Icon, Modal } from '@successmode-ktp/kui';
import { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  isOpen: boolean;
  onClick: () => void;
  title: ReactNode;
  description: ReactNode;
  button: string;
  isFailed?: boolean;
};

export const AlertModal = ({
  isOpen,
  onClick,
  title,
  description,
  button,
  isFailed = false,
}: Props) => {
  return (
    <Modal isOpen={isOpen} hasBackdrop>
      <Wrapper>
        <Modal.Header>
          <TitleWrapper>
            {!isFailed && <Icon.CheckFilled fillColor='#246CF6' />}
            {isFailed && <Icon.WarningFilled fillColor='#FF2D55' />}
            <Title>{title}</Title>
          </TitleWrapper>
        </Modal.Header>
        <Description>{description}</Description>
        <Modal.Footer>
          {isFailed && (
            <Button type='button' theme='mono' onClick={onClick}>
              {button}
            </Button>
          )}
          {!isFailed && (
            <Button type='button' onClick={onClick}>
              {button}
            </Button>
          )}
        </Modal.Footer>
      </Wrapper>
    </Modal>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 300px;
  z-index: 90;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 8px;
  margin-bottom: 16px;
`;

const Title = styled.h6`
  color: #030303;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.45px;
  word-break: keep-all;
`;

const Description = styled.p`
  color: #80848a;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;
